<template>
  <div
    class="FilterFacets"
  >
    <FilterFacetsSidebar
      :visible="show"
      :facets-to-display="facetsToDisplay"
      @close="show = !show"
    />
    <div
      class="FilterFacets__facets"
      :class="{
        'FilterFacets__facets--has-active-option': activeFilterGroup !== '',
      }"
    >
      <div class="FilterFacets__shows-facets-button">
        <div class="FilterFacets__shows-facets-button-wrapper">
          <FilterHeading
            class="FilterFacets__shows-facets-heading"
            title="Refine by"
            desktop-title="All filters"
            icon="filter"
            :selected="show"
            :tracking="false"
            @click="handleShowFilterMenu"
          />
        </div>
      </div>
      <div class="FilterFacets__facets-wrapper">
        <div
          v-if="props.facetsToDisplay.lensColour"
          class="FilterFacets__facet"
          :class="{
            'FilterFacets__facet--active':
              activeFilterGroup ===
              props.facetsToDisplay.lensColour.filterGroupValue,
          }"
        >
          <ListRefinement
            :attribute="props.facetsToDisplay.lensColour"
            :title="props.facetsToDisplay.lensColour.filterGroupDisplayName"
            :group-value="props.facetsToDisplay.lensColour.filterGroupValue"
            :selected="
              activeFilterGroup ===
                props.facetsToDisplay.lensColour.filterGroupValue
            "
            @toggle-active-filter-group="toggleActiveFilterGroup"
          />
        </div>
        <div
          v-if="props.facetsToDisplay.frameColour"
          class="FilterFacets__facet"
          :class="{
            'FilterFacets__facet--active':
              activeFilterGroup ===
              props.facetsToDisplay.frameColour.filterGroupValue,
          }"
        >
          <ListRefinement
            :attribute="props.facetsToDisplay.frameColour"
            :title="props.facetsToDisplay.frameColour.filterGroupDisplayName"
            :group-value="props.facetsToDisplay.frameColour.filterGroupValue"
            :selected="
              activeFilterGroup ===
                props.facetsToDisplay.frameColour.filterGroupValue
            "
            @toggle-active-filter-group="toggleActiveFilterGroup"
          />
        </div>
        <div
          v-if="props.facetsToDisplay.lensTech"
          class="FilterFacets__facet"
          :class="{
            'FilterFacets__facet--active':
              activeFilterGroup ===
              props.facetsToDisplay.lensTech.filterGroupValue,
          }"
        >
          <ListRefinement
            :attribute="props.facetsToDisplay.lensTech"
            :title="props.facetsToDisplay.lensTech.filterGroupDisplayName"
            :group-value="props.facetsToDisplay.lensTech.filterGroupValue"
            :selected="
              activeFilterGroup ===
                props.facetsToDisplay.lensTech.filterGroupValue
            "
            @toggle-active-filter-group="toggleActiveFilterGroup"
          />
        </div>
        <div
          v-if="props.facetsToDisplay.name"
          class="FilterFacets__facet"
          :class="{
            'FilterFacets__facet--active':
              activeFilterGroup === props.facetsToDisplay.name.filterGroupValue,
          }"
        >
          <ListRefinement
            :attribute="props.facetsToDisplay.name"
            :title="props.facetsToDisplay.name.filterGroupDisplayName"
            :group-value="props.facetsToDisplay.name.filterGroupValue"
            :selected="
              activeFilterGroup === props.facetsToDisplay.name.filterGroupValue
            "
            @toggle-active-filter-group="toggleActiveFilterGroup"
          />
        </div>
        <div
          v-if="props.facetsToDisplay.faceSize"
          class="FilterFacets__facet"
          :class="{
            'FilterFacets__facet--active':
              activeFilterGroup ===
              props.facetsToDisplay.faceSize.filterGroupValue,
          }"
        >
          <ListRefinement
            :attribute="props.facetsToDisplay.faceSize"
            :title="props.facetsToDisplay.faceSize.filterGroupDisplayName"
            :group-value="props.facetsToDisplay.faceSize.filterGroupValue"
            :selected="
              activeFilterGroup ===
                props.facetsToDisplay.faceSize.filterGroupValue
            "
            @toggle-active-filter-group="toggleActiveFilterGroup"
          />
        </div>
        <div
          v-if="props.facetsToDisplay.partner"
          class="FilterFacets__facet"
          :class="{
            'FilterFacets__facet--active':
              activeFilterGroup ===
              props.facetsToDisplay.partner.filterGroupValue,
          }"
        >
          <ListRefinement
            :attribute="props.facetsToDisplay.partner"
            :title="props.facetsToDisplay.partner.filterGroupDisplayName"
            :group-value="props.facetsToDisplay.partner.filterGroupValue"
            :selected="
              activeFilterGroup ===
                props.facetsToDisplay.partner.filterGroupValue
            "
            @toggle-active-filter-group="toggleActiveFilterGroup"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FilterGroup } from '~/assets/js/helpers/search/search'

interface Props {
  facetsToDisplay: FilterGroup
}

const { $track } = useNuxtApp()

const props = defineProps<Props>()

const show = ref(false)
const activeFilterGroup = ref('')

function toggleActiveFilterGroup(filterGroup: string) {
  if (activeFilterGroup.value === filterGroup) {
    activeFilterGroup.value = ''
    return
  }

  activeFilterGroup.value = filterGroup
}

async function handleShowFilterMenu() {
  show.value = !show.value
  await $track.global.linkClicked({
    interactionElement: 'Filter menu button',
    interactionSection: 'Open filter sidebar',
  })
}
</script>

<style lang="postcss" scoped>
.FilterFacets__shows-facets-button {
  @apply inline-block lgMax:w-full border-r border-grey-light;
}

.FilterFacets__shows-facets-button-wrapper {
  @apply lgMax:global-wrapper lg:pr-8;
}

.FilterFacets__shows-facets-heading {
  @apply w-full;
}

.FilterFacets__facets {
  @apply flex lg:gap-x-7;
}

.FilterFacets__facets-wrapper {
  @apply hidden;

  @screen lg {
    @apply flex;
  }
}

.FilterFacets__facet {
  @apply global-wrapper lg:global-wrapper-reset;

  &:nth-child(n + 5) {
    display: none;
  }

  @screen xl {
    &:nth-child(5) {
      display: block;
    }
  }

  @media (min-width: 1420px) {
    &:nth-child(n + 5) {
      @apply block;
    }
  }
}

.FilterFacets__facets--has-active-option {
  .FilterFacets__facet {
    opacity: 0.5;
  }

  .FilterFacets__facet--active {
    opacity: 1;
  }
}
</style>
